<template>
	<div class="form-row">
		<div class="form-group col-md-6">
            <label>Intermediario:</label>
            <catalogo-intermediarios id="intermediario" name="CODIGO_INTERMEDIARIO" :value="intermediarioDF" v-model="intermediarioSelect">
            </catalogo-intermediarios>
        </div>

        <div class="form-group col-md-6">
            <label>Ejecutivo:</label>
            <catalogo-ejecutivos id="ejecutivo" name="CODIGO_EJECUTIVO" :value="ejecutivoDF" :Intermediario="intermediarioSelect">
            </catalogo-ejecutivos>
        </div>
	</div>
</template>
<script type="text/javascript">
	export default {
		props: ['intermediario', 'ejecutivo'],
		data(){
			return {
				intermediarioSelect: ''
			}
		},

		mounted(){
			this.intermediarioSelect = this.intermediarioDF	
		},
		computed: {
			intermediarioDF(){
				return this.intermediario
			},

			ejecutivoDF(){
				return this.ejecutivo
			},
		}
	}
</script>